import { gql } from "../gql";
import "./fragments";

export const LOYALTY_TIERS_QUERY = gql(`
  query LoyaltyTiers($franchiseId: ID!) {
    loyaltyTiers(franchiseId: $franchiseId) {
      id
      name
      description
      minPoints
      maxPoints
      color
      priorityBooking
      sortOrder
      isActive
      createdAt
      updatedAt
    }
  }
`);

export const CREATE_LOYALTY_TIER_MUTATION = gql(`
  mutation CreateLoyaltyTier($franchiseId: ID!, $input: CreateTierInput!) {
    createLoyaltyTier(franchiseId: $franchiseId, input: $input) {
      id
      name
      description
      minPoints
      maxPoints
      color
      priorityBooking
      sortOrder
      isActive
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_LOYALTY_TIER_MUTATION = gql(`
  mutation UpdateLoyaltyTier($id: ID!, $input: UpdateTierInput!) {
    updateLoyaltyTier(id: $id, input: $input) {
      id
      name
      description
      minPoints
      maxPoints
      color
      priorityBooking
      sortOrder
      isActive
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_LOYALTY_TIER_MUTATION = gql(`
  mutation DeleteLoyaltyTier($id: ID!) {
    deleteLoyaltyTier(id: $id)
  }
`);

export const REORDER_LOYALTY_TIERS_MUTATION = gql(`
  mutation ReorderLoyaltyTiers($franchiseId: ID!, $tierIds: [ID!]!) {
    reorderLoyaltyTiers(franchiseId: $franchiseId, tierIds: $tierIds) {
      id
      name
      description
      minPoints
      maxPoints
      color
      priorityBooking
      sortOrder
      isActive
      createdAt
      updatedAt
    }
  }
`);
